export const CollectionActionType = {
    CREATE: 'createCollection',
    EDIT: 'edit',
    DELETE: 'delete',
    SHARE_WITH_TEAM: 'shareWithTeam',
    SOCIAL_SHARE: 'socialShare',
    COPY_COLLECTION: 'copyCollection',
};
